export default (selectsArr) => {
  selectsArr.forEach((item) => {
    item.set([]);
  });

  return selectsArr;
};
